export default function Compliance() {
  return (
    <section className="py-20 sm:py-24 lg:py-28 px-4 sm:px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block mb-5 sm:mb-7">
            <span className="border-2 border-[#1e3a8a] text-[#1e3a8a] text-xs font-semibold px-4 sm:px-6 py-2 rounded-full uppercase tracking-wider whitespace-nowrap">
              Compliance
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a8a] mb-5 sm:mb-7 px-4 leading-tight">
            健全な協業のための責任範囲
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-8 sm:p-12 lg:p-16">
          <div className="prose prose-lg max-w-none">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-0">
              当社は旅行業法を厳守し、旅行会社様との健全な分業体制を構築します。旅行契約の締結、代金の受領、および旅行の手配・実施はすべて受託旅行会社様が行い、当社は「マーケティング・広報・コミュニティ内でのファン化」に特化した支援を行います。
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mt-6 mb-0">
              各々の専門領域を明確に分離することで、法的コンプライアンスを完全に遵守した、透明性の高いプロフェッショナルな協業を実現します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}